import { useRouter } from 'next/router'
import type { ReactElement } from 'react'
import { createContext, useContext } from 'react'

type Props = {
  children: ReactElement
}

const FilterContext = createContext<object | undefined>(undefined)

const FilterProvider = ({ children }: Props) => {
  const router = useRouter()
  const { Categories, categories, fuel, Fuel, Featured, featured } =
    router.query

  const PreSelectedCategories = Categories || categories || ''
  const PreSelectedFuel = fuel || Fuel || ''
  const PreSelectedFeatured = featured || Featured || ''

  return (
    <FilterContext.Provider
      value={{
        Categories: PreSelectedCategories,
        Fuel: PreSelectedFuel,
        Featured: PreSelectedFeatured,
      }}
    >
      {children}
    </FilterContext.Provider>
  )
}

const useFilter = () => {
  return useContext(FilterContext)
}

export { FilterProvider, useFilter }
